import { Reveal, ClipImage } from "@/components/store/Reveal";
import { PILLARS } from "@/constants/product";

const Pillar = ({ p, i }) => (
  <Reveal delay={i * 0.08} className="h-full">
    <article className="group flex h-full flex-col rounded-md border border-black/15 bg-[var(--paper)] p-7 transition-colors duration-500 hover:bg-[var(--sage)]" data-testid={`pillar-${p.n}`}>
      <span className="font-display text-6xl text-[var(--sage-deep)] transition-transform duration-500 group-hover:-translate-y-1">{p.n}</span>
      <div className="mt-10">
        <h3 className="font-display text-2xl sm:text-3xl">{p.title}</h3>
        <p className="mt-3 text-[var(--muted)]">{p.text}</p>
      </div>
    </article>
  </Reveal>
);

export const SystemBento = () => (
  <section id="system" className="mx-auto max-w-[1360px] px-5 py-24 sm:px-10 sm:py-32" data-testid="system-section">
    <div className="grid gap-4 lg:grid-cols-12 lg:grid-rows-[minmax(320px,auto)_minmax(300px,auto)_minmax(320px,auto)]">
      <Reveal className="flex flex-col justify-end rounded-md bg-[var(--ink)] p-8 text-[var(--paper)] lg:col-span-5">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--sage)]">The system</p>
        <h2 className="font-display mt-5 text-4xl leading-[1.02] sm:text-5xl">Three habits. One calmer grocery week.</h2>
      </Reveal>
      <div className="aspect-[2/1] lg:col-span-7 lg:aspect-auto"><ClipImage src="/assets/photo-notebook.jpg" alt="Open weekly planner notebook with herbs and beans" testId="bento-photo-notebook" /></div>
      {PILLARS.map((p, i) => <div key={p.n} className="lg:col-span-4"><Pillar p={p} i={i} /></div>)}
      <div className="aspect-[2/1] lg:col-span-8 lg:aspect-auto"><ClipImage src="/assets/photo-pantry.jpg" alt="Pantry staples, apple, lemon and a reusable grocery bag" testId="bento-photo-pantry" /></div>
      <Reveal className="flex flex-col justify-between rounded-md border border-black/15 bg-[var(--sage)] p-8 lg:col-span-4">
        <p className="font-display text-3xl leading-tight">Printable. Reusable. Built around one week at a time.</p>
        <p className="mt-6 text-sm text-[var(--ink)]/75">Print a fresh set every Sunday, or fill it in on screen.</p>
      </Reveal>
    </div>
  </section>
);
